module.exports = __webpack_public_path__ + "static/media/quickshot.84627516.png";